<i18n src="./resources/locales.json"></i18n>
<template>
  <v-dialog v-model="isOpen" max-width="400">
    <v-card class="pa-2" width="400">
      <v-card-title class="headline">{{ $t('errorMessageDialog.title') }}</v-card-title>
      <v-card-text>
        {{ errorMessage }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="sms-primary-button" @click="cancel">
          {{ $t('errorMessageDialog.okButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Attachment from '@/classes/v2/Attachment';
import { MAX_SIZE_KB } from '@/constants/attachments';
import { mapGetters } from 'vuex';

export default {
  name: 'SmsErrorMessageDialog',

  props: {
    file: {}
  },

  data() {
    return {
      isOpen: false,
      errorMessage: null
    }
  },

  computed: {
    ...mapGetters('user', ['activeProvider']),
  },

  methods: {
    openDialog(file) {
      if (file) {
        if (!Attachment.isValidFileType(file.type)) {
          this.errorMessage = this.$t('errorMessageDialog.invalidTypeMessage');
        } else if (!Attachment.isValidFileSize(file.size, this.activeProvider.maxFileSizeKb)) {
          this.errorMessage = this.$t('errorMessageDialog.invalidSizeMessage', {
            size: this.activeProvider.maxFileSizeKb
          });
        }
        this.isOpen = true;
      }
    },

    cancel() {
      this.isOpen = false;
    },
  }
}
</script>
